import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import useStyles from "./styles";
import { FormInput } from "../widgets/FormInput";
import { ActionButton } from "../widgets/ActionButton";
import { Button } from "@material-ui/core";
import { AddRoleModal } from "../models/policy.model";
import { LabelInput } from "../widgets/LabelInput";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `45%`,
    left: `50%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const AddRole = (props) => {
  const classes = useStyles();
  const { open, closeNotes, handleSubmit, roleLoader } = props;
  const [modalStyle] = useState(getModalStyle);
  const [formData, setFormData] = useState(AddRoleModal);

  const handleChange = (e, inputValue, type) => {
    e.persist();
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className={classes.modalBody}>
        <h4 className={classes.modalTitle} id="simple-modal-title">
          Add Role
        </h4>
        <div className={classes.modalContent}>
          <div className="form-group row m-0">
            <div className="col-md-3">
              <LabelInput
                name="role"
                value="Role Name"
                className="defaultLabel"
              />
            </div>
            <div className="col-md-9">
              <FormInput
                id="role"
                type="text"
                size="small"
                name="role"
                value={formData.role}
                fullWidth={true}
                onChange={handleChange}
                multiline={false}
              />
            </div>
          </div>
          <div className="form-group row m-0">
            <div className="col-md-3">
              <LabelInput
                name="description"
                value="Role Description"
                className="defaultLabel"
              />
            </div>
            <div className="col-md-9">
              <FormInput
                id="description"
                type="text"
                size="small"
                name="description"
                value={formData.description}
                fullWidth={true}
                onChange={handleChange}
                multiline={true}
                placeholder="This is multiline text"
              />
            </div>
          </div>
        </div>
        <div className={classes.modalFooter}>
          <ActionButton
            variant="outlined"
            className="cancel"
            type="button"
            onClick={closeNotes}
            buttonLable="Cancel"
            isLoading="none"
          />
          <Button
            variant="contained"
            className="submit"
            type="button"
            onClick={() => handleSubmit(formData)}
            color="primary"
            disabled={roleLoader}
          >
            {roleLoader ? "Saving..." : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={closeNotes}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
};
export default AddRole;
